import { render } from "./message-content.vue?vue&type=template&id=a069e3a0"
import script from "./message-content.vue?vue&type=script&lang=js"
export * from "./message-content.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__